import { ActionTypes } from '../actions';

const initialState = {
  current: {},
  error: '',
};

const AuthorReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_AUTHOR:
      return { current: action.payload, error: '' };
    case ActionTypes.AUTHOR_SAVE_ERROR:
      return { current: state.current, error: action.payload };
    case ActionTypes.DEAUTH_USER:
      return { current: {}, error: '' };
    default:
      return state;
  }
};

export default AuthorReducer;
